// extracted by mini-css-extract-plugin
export default {"inactief":"routering_section_inactief__c3IkM","actief":"routering_section_actief__hfcl7","subtitle":"routering_section_subtitle__JMPSB","title":"routering_section_title__uu+n0"};